const AboutUsData = [
  {
    heading: 'Save Time: ',
    text: 'Saving the time on the travel research and reducing the pain of making decision.',
  },
  {
    heading: 'Unbiased Recommendations: ',
    text: 'Kahan Chale provides unbiased recommendations to its users unlike many travel agents who will recommend the over touristic locations because of higher commissions.',
  },
  {
    heading: 'Unexplored Destinations: ',
    text: 'We have 3 offbeat destinations for every 1 mainstream destination. You will find many unheard locations and your inner traveler will not be able to resist the temptation of exploring all of them.',
  },
  {
    heading: 'Sustainable Tourism: ',
    text: 'Initiating sustainable tourism by recommending unexplored destinations in India to reduce the burden of the over crowded Indian touristic destinations like Goa and Manali.',
  },
  {
    heading: 'Local Tourism: ',
    text: 'Boosting local tourism by suggesting perfect destinations in India which are similar (if not better) to make foregin destinations.',
  },
  {
    heading: 'Reduced Group Conflicts: ',
    text: 'Reducing the conflicts of the group members over which place to visit by taking into consideration the preferences of all the members. Now democracy of the preferences will win.',
  },
]

export default AboutUsData
